/* eslint-disable react-hooks/exhaustive-deps */
import { clarity } from 'react-microsoft-clarity';

// React
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

// Libraries
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import { toastDefs, toastDefsError } from '../../config/toastConfig';
import * as yup from 'yup';
import getValidationErrors from "../../utility/validationErrors";
import moment from "moment";
import 'moment/locale/pt-br';
import DateTimePicker from 'react-datetime-picker';

// Components
import InputDefault from "../../components/form/InputDefault";
import ButtonDefault from "../../components/form/ButtonDefault";
import SearchProfessionalProposal from "../../components/SearchProfessionalProposal";
import DeadlineProposal from "../../components/DeadlineProposal";
import InputMoney from "../../components/form/InputMoney";
import ServicesTags from "../../components/ServicesTags";

// Icons
import { 
    IconAsteristik, 
    IconDetails, 
    IconProfessional, 
    IconServices,
    IconSquarePlus,  
} from "../../components/icons";

// Styles
import { Container, Footer, Header, Hr1, Main } from "./styles";

// Data
import { ModalityAudience } from '../../components/Data/ModalityAudience'
import { EstadosBrasileiros } from "../../components/Data/StatesData";
import { CivilHearing } from "../../components/Data/CivilHearing";
import { CriminalHearing } from "../../components/Data/CriminalHearing";
import { LaborHearing } from "../../components/Data/LaborHearing";
import { AnotherHearing } from "../../components/Data/AnotherHearing";
import { ProfessionalTypeNecessary } from "../../components/Data/ProfessionalTypeNecessary";
import { NotariesTypes } from "../../components/Data/Notaries";

// Services
import api from "../../services/api";
import axios from "axios";
import { comum } from '../../styles/Themes/light';

import LogoLegalOps from '../../components/LogoLegalOps';
import { useAuth } from '../../contexts/UserContext';

// Natureza options
const NaturezaOptions = [
    { value: 'Extrajudicial', label: 'Extrajudicial' },
    { value: 'Judicial', label: 'Judicial' },
    { value: 'Administrativo', label: 'Administrativo' }
];

// Timezone options
const TimezoneOptions = [
    { value: 'FNT', label: 'FNT (UTC -2) - Fernando de Noronha' },
    { value: 'BRT', label: 'BRT (UTC -3) - Brasília' },
    { value: 'AMT', label: 'AMT (UTC -4) - Manaus' },
    { value: 'ACT', label: 'ACT (UTC -5) - Rio Branco' }
];

interface Proposal {
    id_proposta: any,
    id_usuario: any,
    id_servico: any,
    id_comarca: any,
    tags: any,
    arquivos: any,
    numero_processo: string,
    nome_cliente: string,
    valor_cliente: string,
    codigo_cliente: string,
    prazo_aceite: string,
    prazo_para_conclusao: string,
    dias_uteis_para_conclusao: string,
    orientacoes: any,
    tipo_audiencia: string,
    tipo_cartorio: string,
    data: string,
    profissional_necessario: string,
    modalidade: string,
    endereco_virtual: string,
    rua: string,
    bairro: string,
    cep: string,
    numero: string,
    complemento: string,
    valor_profissional?: string,    
    cidade_comarca?: string,
    profile?: string,
    natureza: string,
    timezone?: string,
}

export interface LocationParams {
    title: string,
    type: string,
    pathname: string,
    state: any,
    search: string,
    hash: string,
    key: string,
    name: string,
    proposal: any,
}

export default function HearingForms() {
    const location = useLocation<LocationParams>();
    const { user } = useAuth();
    const history = useHistory();
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ activePage, setActivePage ] = useState<number>(1);
    const [ advancePageError, setAdvancePageError ] = useState<any>();
    const [ dateError, setDateError ] = useState<any>();
    const [ DTOProposal, setDTOProposal ] = useState<Proposal>({
        id_proposta: '',
        id_usuario: '',
        id_servico: '',
        id_comarca: '',
        tags: '',
        arquivos: '',
        numero_processo: '',
        nome_cliente: '',
        valor_cliente: '',
        codigo_cliente: '',
        prazo_aceite: '',
        prazo_para_conclusao: '',
        dias_uteis_para_conclusao: "",
        orientacoes: '',
        tipo_audiencia: '',
        tipo_cartorio: '',
        data: '',
        profissional_necessario: '',
        modalidade: '',
        endereco_virtual: '',
        rua: '',
        bairro: '',
        cep: '',
        numero: '',
        complemento: '',
        valor_profissional: '',
        natureza: 'Judicial',
        timezone: '',
    });
    const [ formTitle, setFormTitle ] = useState<any>();
    const [ proposalType, setProposalType ] = useState<any>();
    const [ dateHearing, setDateHearing ] = useState<Date | undefined>(undefined);
    const [ counties, setCounties ] = useState<any>();
    const [ tagsSelecteds, setTagSelecteds ] = useState<any>();
    const [ countieProps, setCountieProps ] = useState<any>();
    const [ nameProfessional, setNameProfessional ] = useState<any>();
    const [ deadline, setDeadline ] = useState<any>();
    const [ reuseProposal, setReuseProposal ] = useState<any>();
    const [ selectedTimezone, setSelectedTimezone ] = useState<any>(TimezoneOptions[1]); // Default to BRT (Brasília)


    let cepData = {
        uf: '',
        localidade: '',
        bairro: '',
        logradouro: '',
    }

    const states = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            border: advancePageError?.uf ? `1px solid   ${comum.colors.primaryRed400}`: '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }

    const city = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            border: advancePageError?.id_comarca ? `1px solid   ${comum.colors.primaryRed400}`: '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }  

    const hearing = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            border: advancePageError?.tipo_audiencia ? `1px solid   ${comum.colors.primaryRed400}`: '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }  

    const modalities = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            border: advancePageError?.modalidade ? `1px solid   ${comum.colors.primaryRed400}`: '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }  

    const professional = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            border: advancePageError?.profissional_necessario ? `1px solid   ${comum.colors.primaryRed400}`: '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }

    const natureza = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            border: advancePageError?.natureza ? `1px solid   ${comum.colors.primaryRed400}`: '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }

    const timezone = {
        control: (provided: Record<string, unknown>) => ({
            ...provided,
            height: 48,
            boxShadow: "none",
            cursor: 'pointer',
            border: advancePageError?.timezone ? `1px solid   ${comum.colors.primaryRed400}`: '1px solid #EAEEF3',
            '&:hover': {
                border: `1px solid ${comum.colors.interfaceTextGray}`,
            },
        }),
        placeholder: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
            fontWeight: '400',
        }),
        singleValue: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c353a40)',
            fontSize: '16px',
        }),
        option: (provided: Record<string, unknown>) => ({
            ...provided,
            color: 'var(--c5a646e)',
            fontSize: '16px',
            fontWeight: '500',
        }),
    }  
    
    useEffect(() => {   
        // console.log('log da proposta duplicada', location.state.proposal);

        setFormTitle(location.state.title);
        setProposalType(location.state.type);        

        if (location.state.title === 'Comparecimento em cartório') {
            handleOnChange('id_servico', 6)
        }

        if (location.state.title === 'Cópia parcial') {
            handleOnChange('id_servico', 9)
        }

        if (location.state.title === 'Cópia integral') {
            handleOnChange('id_servico', 8)
        }

        if (location.state.title === 'Acautelamento') {
            handleOnChange('id_servico', 13)
        }

        if (location.state.title === 'Acompanhamento de atos oficiais') {
            handleOnChange('id_servico', 5)
        }

        if (location.state.title === 'Despacho') {
            handleOnChange('id_servico', 10)
        }

        if (location.state.title === 'Retirada de ofício e alvará') {
            handleOnChange('id_servico', 11)
        }

        if (location.state.title === 'Diligência') {
            handleOnChange('id_servico', 12)
        }

        if (location.state.title === 'Protocolo eletrônico') {
            handleOnChange('id_servico', 14)
        }

        if (location.state.title === 'Protocolo físico') {
            handleOnChange('id_servico', 15)
        }

        if (location.state.title === 'Protocolo postal') {
            handleOnChange('id_servico', 16)
        }

        if (location.state.title === 'Petições') {
            handleOnChange('id_servico', 22)
        }

        if (location.state.title === 'Outro Serviço') {
            handleOnChange('id_servico', 21)
        }

        if (location.state.name === 'Reuse') {
            setDTOProposal({
                id_proposta: location.state.proposal.id_proposta,
                id_usuario: location.state.proposal.id_usuario,
                id_servico: location.state.proposal.id_servico,
                id_comarca: location.state.proposal.id_comarca,
                tags: location.state.proposal.tags,
                arquivos: location.state.proposal.arquivos,
                numero_processo: location.state.proposal.numero_processo,
                nome_cliente: location.state.proposal.nome_cliente,
                valor_cliente: typeof location.state.proposal.valor_cliente === 'number' 
                    ? location.state.proposal.valor_cliente.toFixed(2) 
                    : location.state.proposal.valor_cliente?.toString() || '0.00',
                codigo_cliente: location.state.proposal.codigo_cliente,
                prazo_aceite: location.state.proposal.prazo_aceite,
                prazo_para_conclusao: location.state.proposal.prazo_para_conclusao,
                dias_uteis_para_conclusao: location.state.proposal.dias_uteis_para_conclusao,
                orientacoes: location.state.proposal.orientacoes[0],
                tipo_audiencia: location.state.proposal.tipo_audiencia,
                tipo_cartorio: location.state.proposal.tipo_cartorio || '',
                data: location.state.proposal.data,
                profissional_necessario: location.state.proposal.profissional_necessario,
                modalidade: location.state.proposal.modalidade,
                endereco_virtual: location.state.proposal.endereco_virtual,
                rua: location.state.proposal.rua,
                bairro: location.state.proposal.bairro,
                cep: location.state.proposal.cep,
                numero: location.state.proposal.numero,
                complemento: location.state.proposal.complemento,
                valor_profissional: typeof location.state.proposal.valor_profissional === 'number' 
                    ? location.state.proposal.valor_profissional.toFixed(2) 
                    : location.state.proposal.valor_profissional?.toString() || '0.00',
                natureza: location.state.proposal.natureza || 'Judicial',
                timezone: location.state.proposal.timezone || '',
            });
            setTagSelecteds(location.state.proposal.tags)

            // Set timezone if it exists in the reused proposal
            if (location.state.proposal.timezone) {
                const timezoneOption = TimezoneOptions.find(option => option.value === location.state.proposal.timezone);
                if (timezoneOption) {
                    setSelectedTimezone(timezoneOption);
                }
            }

            getCountiesById();
            setReuseProposal(true);           

            if (location.state.proposal.descricao_servico_completo.includes('Audiências Trabalhista')) {
                setFormTitle('Audiência Trabalhista');
                setProposalType('Audiência');
            }

            if (location.state.proposal.descricao_servico_completo.includes('Audiências Cível')) {
                setFormTitle('Audiência Cível');
                setProposalType('Audiência');
            }

            if (location.state.proposal.descricao_servico_completo.includes('Audiências Penal')) {
                setFormTitle('Audiência Penal');
                setProposalType('Audiência');
            }

            if (location.state.proposal.descricao_servico_completo.includes('Audiências Outros')) {
                setFormTitle('Audiências');
                setProposalType('Audiência');
            }

            if (location.state.proposal.descricao_servico_completo.includes('Protocolos')) {
                setFormTitle('Protocolos');
            }

            if (location.state.proposal.descricao_servico_completo.includes('Diligências')) {
                setFormTitle('Diligencia');
            }


        }
        
    }, [formTitle, proposalType])

    useEffect(() => {
        if (DTOProposal.id_comarca !== '') {
            getCountiesById();
            // console.log('log do countie Id', DTOProposal.id_comarca)
        }        
    }, [DTOProposal.id_comarca])

    useEffect(() => {
        
        if (formTitle === 'Audiência Cível' && DTOProposal.modalidade === 'presencial') {

            handleOnChange('id_servico', 1);
            
        }

        if (formTitle === 'Audiência Cível' && DTOProposal.modalidade === 'online') {

            handleOnChange('id_servico', 17)
        }

        if (formTitle === 'Audiência Penal' && DTOProposal.modalidade === 'presencial') {
            handleOnChange('id_servico', 3)
        }

        if (formTitle === 'Audiência Penal' && DTOProposal.modalidade === 'online') {
            handleOnChange('id_servico', 19)
            
        }

        if (formTitle === 'Audiência Trabalhista' && DTOProposal.modalidade === 'presencial') {
            handleOnChange('id_servico', 2)
        }

        if (formTitle === 'Audiência Trabalhista' && DTOProposal.modalidade === 'online') {
            handleOnChange('id_servico', 18)
        }

        if (formTitle === 'Audiências' && DTOProposal.modalidade === 'presencial') {
            handleOnChange('id_servico', 4)
        }

        if (formTitle === 'Audiências' && DTOProposal.modalidade === 'online') {
            handleOnChange('id_servico', 20)       
        }  

    }, [DTOProposal.modalidade])

    function handleOnChangeMoney(name: any, value: any) {

        let newValue = value.replace(/\D/g, '');

        if (newValue.charAt(0) === '0') {
            newValue = newValue.substring(1)           
        } else {

            let txtArray = newValue.split('')
            txtArray.splice(txtArray.length - 2, 0, ".");
            var correctedValue = txtArray.join('')

            const newDTO: any = DTOProposal
            newDTO[name] = correctedValue
            setDTOProposal({ ...newDTO })

        }        

    }

    function handleOnChange(name: any, value: any) {

        const newDTO: any = DTOProposal
        newDTO[name] = value
        setDTOProposal({ ...newDTO })

    }

    async function getCounties(selected: any) {
        
        try {

            const countieArray: {value: any, label: any}[] = []

            // axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${selected.value}/municipios`).then(response => {
            //     response.data.map((row: any) => {
            //         countieArray.push({
            //             value: row.nome,
            //             label: row.nome
            //         })
            //     })
            //     setCounties(countieArray)
            // });
            
            const response = await api.get(`comarca?uf=${selected.value}`)
            
            if(response.data.status !== 'success') {
                throw new Error();
            }

            response.data.result.map((row: any) => (
                countieArray.push({
                    label: row.cidade,
                    value: row.id_comarca
                })
            ))            
            
            setCounties(countieArray)

        } catch (error: any) {

            toast.error(error, toastDefsError);
        }

    }

    async function getCountiesById() {
        
        try {
            
            if (location.state.name === 'Reuse') {
                setLoading(true);

                const response = await api.get(`/comarca/${location.state.proposal.id_comarca}`)
                setCountieProps(response.data.result);
                
                if (response.data.status !== 'success') {
                    throw new Error();
                }

                setLoading(false);

            } else {
                setLoading(true);

                const response = await api.get(`/comarca/${DTOProposal.id_comarca}`)
                setCountieProps(response.data.result)            
                
                if(response.data.status !== 'success') {
                    throw new Error();
                }

                setLoading(false);
            }

            

        } catch (error: any) {

            setLoading(false);
           
            toast.error(error, toastDefsError);
        }

    }

    function scrollTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    async function advancePage() {

        try {

            if (activePage === 1) {             

                const actualDate = new Date();

                let schema_data: any = {
                    id_comarca: yup.string().required('Cidade é obrigatório'),
                    numero_processo: yup.string().required(
                        DTOProposal.natureza === 'Judicial'
                            ? 'Número do processo é obrigatório'
                            : 'O campo Número de Identificação é obrigatório'
                    ),
                    natureza: yup.string().required('Natureza é obrigatória'),
                }

                if(user.profile !== 'Solicitante') {
                    schema_data = {
                        valor_cliente: yup.string()
                            .required('Valor do cliente é obrigatório')
                            .test('maior-que-zero', 'Valor do cliente deve ser maior que zero', function(value) {
                                if (!value) return false;
                                const numericValue = parseFloat(value);
                                return !isNaN(numericValue) && numericValue > 0;
                            }),
                        codigo_cliente: yup.string().required('Código do cliente é obrigatório'),
                        nome_cliente: yup.string().required('Nome é obrigatório'),
                        ...schema_data
                    }
                }
                
                // Validação do Prazo Fatal para todas as demandas
                if (!dateHearing) {
                    throw new Error('O Prazo Fatal é obrigatório')
                }
                
                const horas = dateHearing.getHours();
                const minutos = dateHearing.getMinutes();
                const segundos = dateHearing.getSeconds();
                const milissegundos = dateHearing.getMilliseconds();
                
                if (horas === 0 && minutos === 0 && segundos === 0 && milissegundos === 0) {
                    throw new Error('Data e hora fatal são obrigatórias')
                }
                
                if (dateHearing < actualDate) {
                    throw new Error('O Prazo Fatal deve ser maior que a data atual')
                }

                // Validação do Fuso Horário
                if (!selectedTimezone) {
                    throw new Error('O Fuso Horário é obrigatório')
                }
                setDateError(false);
                const date = moment(dateHearing).format("YYYY-MM-DD HH:mm:ss")
                handleOnChange('data', date);
                handleOnChange('timezone', selectedTimezone.value);

                if (
                    formTitle === 'Audiência Cível' || 
                    formTitle === 'Audiência Penal' ||
                    formTitle === 'Audiência Trabalhista' ||
                    formTitle === 'Audiências'
                ) {
                    schema_data = {
                        ...schema_data,
                        profissional_necessario: yup.string().required('Profissional necessário é obrigatório'),
                        tipo_audiencia: yup.string().required('Tipo de audiência é obrigatório'),
                        modalidade: yup.string().required('Modalidade é obrigatório'),
                    }
                }      
                


                const schema = yup.object().shape(schema_data);

                await schema.validate(DTOProposal, {
                    abortEarly: false,
                });

                setActivePage(activePage + 1);
            }

            if (activePage === 2) {

                handleOnChange('tags', tagsSelecteds);

                if (DTOProposal.valor_profissional === '.') {
                    handleOnChange('valor_profissional', 0)
                }

                if(user.profile !== 'Solicitante') {
                    const valorProfissional = parseFloat(DTOProposal.valor_profissional || '0');
                    if (isNaN(valorProfissional) || valorProfissional <= 0) {
                        throw new Error('Valor do serviço é obrigatório e deve ser maior que zero');
                    }
                    setActivePage(activePage + 1);
                } else {
                    setActivePage(activePage + 2);
                }
            }

            if (activePage === 3) {
                
                if(DTOProposal.id_usuario === '') {
                    throw new Error('Selecione um profissional antes de avançar')
                }

                setActivePage(activePage + 1);

            }

            if (activePage === 4) {
                // Caso complete o envio de formulário e de OK
                if (DTOProposal.prazo_aceite === DTOProposal.prazo_para_conclusao) {

                    throw new Error('Os prazos não podem ser iguais');

                }

                handleSubmit();
                
            }

            scrollTop();
            setAdvancePageError({})


        } catch (err: any) {

            if (activePage === 1) {

                if (err instanceof yup.ValidationError) {
                    const errors = getValidationErrors(err);
                    console.log('log do erro cópia parcial', errors)

                    setAdvancePageError(errors)

                    toast.error('Preencha os campos corretamente.', toastDefsError);
                } else {

                    setDateError(true);

                    toast.error(err.message, toastDefsError);

                }
            }

            if (activePage === 2) {
                
                toast.error(err.message, toastDefsError);
            }

            if (activePage === 3) {

                toast.error(err.message, toastDefsError);
            }

            if (activePage === 4) {

                toast.error(err.message, toastDefsError);
            }


        }
    }

    useEffect(() => {
        if (DTOProposal.id_usuario) {
            getUserName();
        }
    }, [DTOProposal])

    async function getUserName() {
        try {
            setLoading(true);
            const response = await api.get(`/usuario/${DTOProposal.id_usuario}`);
            setNameProfessional(response.data.result.nome);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('log error user name', error);
        }
    }

    async function handleSubmit() {

        try {

            setLoading(true);
            clarity.setEvent('cria-proposta')

            let requestProposal = user.profile === 'Solicitante' ? 'proposta/solicitante' : 'proposta'            
            const response = await api.post(requestProposal, DTOProposal)

            if (response.data.status !== 'success') {

                if (response.data.result.length > 0) {
                    
                    throw (response.data.result)
                    
                } else {

                    throw new Error(response.data.message);
                }
            }

            if (response.data.status === 'success') {
                history.push({
                    pathname: '/proposta/concluir',
                    state: {
                        userName: nameProfessional,
                        id: DTOProposal.id_usuario,
                        prazo: deadline,
                        proposalId: response.data.result
                    }
                })
                setLoading(false);
            }

        } catch (error: any) {            

            setLoading(false);

            if (error.length > 0) {
                error.map((row: any) => (
                    toast.error(row.message, toastDefsError)
                ))

            } else {
                toast.error(error.message, toastDefsError);
            }


        }


    }       

    async function consultCep(value: any) {
        
        try {
            const cepLimpo = value.replace(/\D/g, '');

            if (cepLimpo.length !== 8) {
                return;
            }

            handleOnChange('cep', cepLimpo);
            const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`)
            const data = response.data

            if (data.erro) {
                toast.error('CEP não encontrado. Verifique o CEP digitado.', toastDefsError);
                return;
            }

            cepData = {
                uf: data.uf,
                localidade: data.localidade,
                bairro: data.bairro,
                logradouro: data.logradouro,
            }

            handleOnChange('rua', data.logradouro || '');
            handleOnChange('bairro', data.bairro || '');

            if (!countieProps?.uf || countieProps.uf.trim() === '') {
                const estadoSelecionado = EstadosBrasileiros.find(estado => estado.value === data.uf);
                if (estadoSelecionado) {
                    await getCounties(estadoSelecionado);
                }
            }

        } catch (err: any) {

            console.error('Erro ao buscar CEP:', err);
            toast.error('Erro ao buscar CEP. Tente novamente.', toastDefsError);
                        
        }

    }

    // useEffect(() => {
    //     if (oldProposalDate) {

    //         const date = moment(oldProposalDate).format("YYYY-MM-DD HH:mm:ss")
    //         handleOnChange('data', date)            

    //     }

    //     // if (dateHearing) {

    //     //     const date = moment(dateHearing).format("YYYY-MM-DD HH:mm:ss")
    //     //     handleOnChange('data', date)            

    //     // }

    // }, [oldProposalDate, dateHearing]);

    // Funções para regras RN7 - Campo dinâmico baseado na natureza
    const getProcessFieldTitle = () => {
        return DTOProposal.natureza === 'Judicial' ? 'Número do processo:' : 'Número para identificação:';
    };

    const getProcessFieldMask = () => {
        return DTOProposal.natureza === 'Judicial' ? '9999999-99.9999.9.99.9999' : '';
    };

    const handleProcessFieldChange = (value: string) => {
        // Remove caracteres não numéricos
        const numericValue = value.replace(/\D/g, '');
        
        // Limita o tamanho máximo
        const limitedValue = numericValue.slice(0, 20);
        
        handleOnChange('numero_processo', limitedValue);
    };

    // Limpa o campo quando a natureza mudar
    useEffect(() => {
        if (DTOProposal.numero_processo) {
            // Se mudou de Judicial para não-Judicial ou vice-versa, limpa o campo
            const currentValue = DTOProposal.numero_processo;
            const hasMask = currentValue.includes('-') || currentValue.includes('.');
            const shouldHaveMask = DTOProposal.natureza === 'Judicial';
            
            if (hasMask !== shouldHaveMask) {
                // Limpa o campo para evitar conflito de formatos
                handleOnChange('numero_processo', '');
            }
        }
    }, [DTOProposal.natureza]);

    return (
        <Container>

            <Header>
                {/* <div className="logo"><IconLogoJuridico /></div> */}
                <div className="logo"><LogoLegalOps alt="Logo EasyJur LegalOps" /></div>

                <div className="status">
                    <Hr1
                        className={
                            activePage === 1 ? "first" : 
                            activePage === 2 ? "second" : 
                            activePage === 3 ? "third" : 
                            activePage === 4 ? 'fourth' : ''
                        }
                    />
                    <div
                        className="status-square first"
                    >
                        <div className={"square active"}>
                            <IconServices color={comum.colors.primaryRed400} />
                        </div>
                        <p className="first">Serviço</p>
                    </div>
                    <div
                        className="status-square"
                    >
                        <div className={activePage > 1 ? "square active" : 'square'}>
                            <IconDetails />
                        </div>
                        <p className={activePage > 1 ? 'on second' : 'second'} >Detalhes</p>
                    </div>
                    {
                        user.profile !== 'Solicitante' &&
                    <div
                        className="status-square"
                    >
                        <div className={activePage > 2 ? "square active" : 'square'}>
                            <IconProfessional />
                        </div>
                        <p className={activePage > 2 ? 'on third' : 'third'} >Profissional</p>
                    </div>
                    }
                    <div
                        className="status-square"
                    >
                        <div className={activePage > 3 ? "square active" : 'square'}>
                            <IconSquarePlus />
                        </div>
                        <p className={activePage > 3 ? 'on fourth' : 'fourth'} >Proposta</p>
                    </div>
                </div>
            </Header>

            <Main>
                <div className="top">
                    {
                        activePage === 1 &&
                        <div className="one" >
                            <div className="register operator">
                                <h3>{formTitle}</h3>
                                <p>Informe os dados para localizarmos o profissional apropriado.</p>
                            </div>
                        </div>
                    }

                    {
                        activePage === 2 &&
                        <div className="two">
                            <div className="register services">
                                <h3>Descreva o serviço para o profissional!</h3>                                
                            </div>
                        </div>
                    }

                    {
                        activePage === 3 &&
                        <div className="three">
                            <div className="register permission">
                                <h3>Encontre o profissional ideal para o serviço!</h3>
                                <div className="subtitle">
                                    Selecione um profissional de acordo com a comarca, disponibilidade e valor tabelado.
                                </div>
                            </div>
                        </div>
                    }

                    {
                        activePage === 4 &&
                        <div className="four">
                            <div className="register deadlines">
                                <h3>Defina prazos para o atendimento!</h3>
                            </div>
                        </div>
                    }

                    {advancePageError && activePage === 1 &&
                        Object.keys(advancePageError).length > 0
                        ? <div>
                            <div className="attention">
                                <div className="star"><IconAsteristik /></div>
                                <span>Atenção:</span>
                                <p>Existem campos obrigatórios a serem preenchidos</p>
                            </div>
                        </div>
                        : ''
                    }

                    {advancePageError && activePage === 2 &&
                        Object.keys(advancePageError).length > 0
                        ? <div>
                            <div className="attention">
                                <div className="star"><IconAsteristik /></div>
                                <span>Atenção:</span>
                                <p>{advancePageError.ilhas}</p>
                            </div>
                        </div>
                        : ''
                    }

                    {advancePageError && activePage === 3 &&
                        Object.keys(advancePageError).length > 0
                        ? <div>
                            <div className="attention">
                                <div className="star"><IconAsteristik /></div>
                                <span>Atenção:</span>
                                <p>Selecione no mínimo 1 setor.</p>
                            </div>
                        </div>
                        : ''
                    }

                </div>

                {
                    activePage === 1 &&                    
                    <form className="register-form">
                        <div className="state">
                            {
                                !loading &&
                                <>
                                    <div className="label-state">
                                        <p>Estado:</p>
                                        <Select
                                            name="estados"
                                            styles={states}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: comum.colors.interfacePure100,
                                                    primary50: comum.colors.interfacePure100,
                                                    primary: comum.colors.interfacePure100,
                                                },
                                            })}
                                            placeholder='Selecionar'
                                            defaultValue={countieProps ? { value: countieProps?.uf, label: countieProps?.uf } : ''}
                                            onChange={getCounties}
                                            options={EstadosBrasileiros}
                                        />
                                        <span className="error">{advancePageError?.uf ? '*' : ''}</span>
                                    </div>

                                    <div className="label-state">
                                        <p>Comarca:</p>
                                        <Select
                                            styles={city}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: comum.colors.interfacePure100,
                                                    primary50: comum.colors.interfacePure100,
                                                    primary: comum.colors.interfacePure100,
                                                },
                                            })}
                                            name='id_comarca'
                                            placeholder="Selecionar"
                                            defaultValue={countieProps ? { value: countieProps?.cidade, label: countieProps?.cidade } : ''}
                                            options={counties}
                                            onChange={(e: any) => handleOnChange('id_comarca', e.value)}
                                            // onChange={(selected: any) => handleOnChange('cidade_comarca', selected.value)}
                                        />
                                        <span className="error">{advancePageError?.id_comarca ? '*' : ''}</span>
                                    </div>
                                </>
                            }
                        </div>

                        <div className="process-natureza">
                            <div className="process-field">
                                <InputDefault
                                    title={getProcessFieldTitle()}
                                    name="numero_processo"
                                    value={DTOProposal.numero_processo}
                                    mask={getProcessFieldMask()}
                                    onChangeText={handleProcessFieldChange}
                                    className={advancePageError?.numero_processo ? 'big error' : 'big'}
                                    error={advancePageError?.numero_processo ? '*' : ''}
                                />
                            </div>
                            
                            <div className="natureza-field">
                                <div className="label-state">
                                    <p>Natureza:</p>
                                    <Select
                                        name="natureza"
                                        styles={natureza}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 8,
                                            colors: {
                                                ...theme.colors,
                                                primary25: comum.colors.interfacePure100,
                                                primary50: comum.colors.interfacePure100,
                                                primary: comum.colors.interfacePure100,
                                            },
                                        })}
                                        placeholder='Selecionar'
                                        defaultValue={{ value: DTOProposal.natureza, label: DTOProposal.natureza }}
                                        onChange={(selected: any) => handleOnChange('natureza', selected.value)}
                                        options={NaturezaOptions}
                                    />
                                    <span className="error">{advancePageError?.natureza ? '*' : ''}</span>
                                </div>
                            </div>
                        </div>

                            {
                                user.profile !== 'Solicitante' &&
                                <div className="name">
                                    <InputDefault
                                        title="Nome:"
                                        name='nome'
                                        value={DTOProposal.nome_cliente}
                                        onChangeText={(value) => handleOnChange('nome_cliente', value)}
                                        className={advancePageError?.nome_cliente ? 'big error' : 'big'}
                                        error={advancePageError?.nome_cliente ? '*' : ''}
                                    />

                            <InputDefault
                                title="Código do cliente:"
                                name="codigo_cliente"
                                placeholder="C0000"
                                value={DTOProposal.codigo_cliente.toLocaleUpperCase()}
                                onChangeText={(value) => handleOnChange('codigo_cliente', value)}
                                className={advancePageError?.codigo_cliente ? 'small error' : 'small'}
                                error={advancePageError?.codigo_cliente ? '*' : ''}
                            />
                        </div>
                        }

                        <div className="values">
                            {
                                user.profile !== 'Solicitante' &&
                            <InputMoney
                                title="Valor do cliente:"
                                name="valor_cliente"
                                mask="R$ 999.999,99"
                                placeholder="R$ 0,00"
                                value={DTOProposal?.valor_cliente}
                                onChangeText={(value) => handleOnChangeMoney('valor_cliente', value)}
                                className={advancePageError?.valor_cliente ? 'small error' : 'small'}
                                error={advancePageError?.valor_cliente ? '*' : ''}
                            />
                            }
                            {
                                user.profile !== 'Solicitante' &&
                            <InputMoney
                                title="Valor do serviço:"
                                name="valor_profissional"
                                mask="R$ 999.999,99"
                                placeholder="R$ 0,00"
                                value={DTOProposal?.valor_profissional}
                                onChangeText={(value) => handleOnChangeMoney('valor_profissional', value)}
                                className={advancePageError?.valor_cliente ? 'small error' : 'small'}
                                error={advancePageError?.valor_profissional ? '*' : ''}
                            />
                            }
                        </div>

                        <div className="prazo-fatal">
                            <div className="label-state">
                                <p>Prazo Fatal:</p>
                                <DateTimePicker
                                    onChange={setDateHearing}
                                    value={dateHearing}
                                    calendarIcon={null}
                                    disableClock={true}
                                    className={dateError ? 'date-error' : 'date'}
                                    name="data"
                                    required={true}
                                />
                                <span className="error">{dateError ? '*' : ''}</span>
                            </div>
                            <div className="label-state">
                                <p>Fuso Horário:</p>
                                <Select
                                    name="timezone"
                                    styles={timezone}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        colors: {
                                            ...theme.colors,
                                            primary25: comum.colors.interfacePure100,
                                            primary50: comum.colors.interfacePure100,
                                            primary: comum.colors.interfacePure100,
                                        },
                                    })}
                                    placeholder='Selecionar'
                                    value={selectedTimezone}
                                    onChange={(selected: any) => setSelectedTimezone(selected)}
                                    options={TimezoneOptions}
                                />
                                <span className="error">{advancePageError?.timezone ? '*' : ''}</span>
                            </div>
                        </div>

                        {
                            proposalType === 'Audiência' &&
                            <div className="bottom">

                                <div className="subtitle">
                                    Para <span>audiências</span>, informe também:
                                </div>

                                <div className="subtype">
                                    <div className="label-state">
                                        <p>Subtipo:</p>
                                        {
                                            formTitle === 'Audiência Cível' &&
                                            <>
                                                <Select
                                                    name="tipo_audiencia"
                                                    styles={hearing}
                                                    components={{
                                                        IndicatorSeparator: () => null
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 8,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: comum.colors.interfacePure100,
                                                            primary50: comum.colors.interfacePure100,
                                                            primary: comum.colors.interfacePure100,
                                                        },
                                                    })}
                                                    placeholder='Selecionar'
                                                    defaultValue={DTOProposal.tipo_audiencia !== '' ? { value: DTOProposal.tipo_audiencia, label: DTOProposal.tipo_audiencia } : ''}
                                                    onChange={(selected: any) => handleOnChange('tipo_audiencia', selected.value)}
                                                    options={CivilHearing}
                                                />
                                                {/* <span className="error">{advancePageError?.tipo_audiencia ? '*' : ''}</span> */}
                                            </>
                                        }
                                        {
                                            formTitle === 'Audiência Penal' &&
                                            <>
                                                <Select
                                                    name="tipo_audiencia"
                                                    styles={hearing}
                                                    components={{
                                                        IndicatorSeparator: () => null
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 8,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: comum.colors.interfacePure100,
                                                            primary50: comum.colors.interfacePure100,
                                                            primary: comum.colors.interfacePure100,
                                                        },
                                                    })}
                                                    placeholder='Selecionar'
                                                    defaultValue={DTOProposal.tipo_audiencia !== '' ? { value: DTOProposal.tipo_audiencia, label: DTOProposal.tipo_audiencia } : ''}
                                                    onChange={(selected: any) => handleOnChange('tipo_audiencia', selected.value)}
                                                    options={CriminalHearing}
                                                />
                                                {/* <span className="error">{advancePageError?.tipo_audiencia ? '*' : ''}</span> */}
                                            </>
                                        }
                                        {
                                            formTitle === 'Audiência Trabalhista' &&
                                            <>
                                                <Select
                                                    name="tipo_audiencia"
                                                    styles={hearing}
                                                    components={{
                                                        IndicatorSeparator: () => null
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 8,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: comum.colors.interfacePure100,
                                                            primary50: comum.colors.interfacePure100,
                                                            primary: comum.colors.interfacePure100,
                                                        },
                                                    })}
                                                    placeholder='Selecionar'
                                                    defaultValue={DTOProposal.tipo_audiencia !== '' ? { value: DTOProposal.tipo_audiencia, label: DTOProposal.tipo_audiencia } : ''}
                                                    onChange={(selected: any) => handleOnChange('tipo_audiencia', selected.value)}
                                                    options={LaborHearing}
                                                />
                                                {/* <span className="error">{advancePageError?.tipo_audiencia ? '*' : ''}</span> */}
                                            </>
                                        }
                                        {
                                            formTitle === 'Audiências' &&
                                            <>
                                                <Select
                                                    name="tipo_audiencia"
                                                    styles={hearing}
                                                    components={{
                                                        IndicatorSeparator: () => null
                                                    }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 8,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: comum.colors.interfacePure100,
                                                            primary50: comum.colors.interfacePure100,
                                                            primary: comum.colors.interfacePure100,
                                                        },
                                                    })}
                                                    placeholder='Selecionar'
                                                    defaultValue={DTOProposal.tipo_audiencia !== '' ? { value: DTOProposal?.tipo_audiencia, label: DTOProposal?.tipo_audiencia } : ''}
                                                    onChange={(selected: any) => handleOnChange('tipo_audiencia', selected.value)}
                                                    options={AnotherHearing}
                                                />
                                                {/* <span className="error">{advancePageError?.tipo_audiencia ? '*' : ''}</span> */}
                                            </>
                                        }

                                        <span className="error">{advancePageError?.tipo_audiencia ? '*' : ''}</span>
                                    </div>

                                    <div className="label-state">
                                        <p>Modalidade:</p>
                                        <Select
                                            name="modalidade"
                                            styles={modalities}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: comum.colors.interfacePure100,
                                                    primary50: comum.colors.interfacePure100,
                                                    primary: comum.colors.interfacePure100,
                                                },
                                            })}
                                            placeholder='Selecionar'
                                            defaultValue={DTOProposal.modalidade !== '' ? { value: DTOProposal.modalidade, label: DTOProposal.modalidade } : ''}
                                            onChange={(selected: any) => handleOnChange('modalidade', selected.value)}
                                            options={ModalityAudience}
                                        />
                                        <span className="error">{advancePageError?.modalidade ? '*' : ''}</span>
                                    </div>
                                </div>

                                <div className="professional">
                                    <div className="label-state">
                                        <p>Profissional necessário:</p>
                                        <Select
                                            name="profissional_necessario"
                                            styles={professional}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 8,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: comum.colors.interfacePure100,
                                                    primary50: comum.colors.interfacePure100,
                                                    primary: comum.colors.interfacePure100,
                                                },
                                            })}
                                            placeholder='Selecionar'
                                            defaultValue={DTOProposal.profissional_necessario !== '' ? { value: DTOProposal.profissional_necessario, label: DTOProposal.profissional_necessario } : ''}
                                            onChange={(selected: any) => handleOnChange('profissional_necessario', selected.value)}
                                            options={ProfessionalTypeNecessary}
                                        />
                                        <span className="error">{advancePageError?.profissional_necessario ? '*' : ''}</span>
                                    </div>


                                </div>

                                <div className="address">
                                    <InputDefault
                                        title="CEP:"
                                        name="Cep"
                                        value={DTOProposal.cep}
                                        mask="99999-999"
                                        onChangeText={(value) => consultCep(value)}
                                        className={advancePageError?.email_profissional ? 'small error' : 'small'}
                                        error={advancePageError?.email_profissional ? '*' : ''}
                                    />
                                    <InputDefault
                                        title="Rua:"
                                        name="rua"
                                        value={cepData.logradouro || DTOProposal.rua}
                                        onChangeText={(value) => handleOnChange('rua', value)}
                                        className={advancePageError?.email_profissional ? 'big error' : 'big'}
                                        error={advancePageError?.email_profissional ? '*' : ''}
                                    />
                                    <InputDefault
                                        title="Bairro:"
                                        name="bairro"
                                        value={cepData.bairro || DTOProposal.bairro}
                                        onChangeText={(value) => handleOnChange('bairro', value)}
                                        className={advancePageError?.email_profissional ? 'mid error' : 'mid'}
                                        error={advancePageError?.email_profissional ? '*' : ''}
                                    />
                                    <InputDefault
                                        title="Número:"
                                        name="numero"
                                        value={DTOProposal.numero}
                                        onChangeText={(value) => handleOnChange('numero', value)}
                                        className={advancePageError?.email_profissional ? 'num error' : 'num'}
                                        error={advancePageError?.email_profissional ? '*' : ''}
                                    />
                                    <InputDefault
                                        title="Complemento:"
                                        name="complemento"
                                        value={DTOProposal.complemento}
                                        onChangeText={(value) => handleOnChange('complemento', value)}
                                        className={advancePageError?.email_profissional ? 'comp error' : 'comp'}
                                        error={advancePageError?.email_profissional ? '*' : ''}
                                    />
                                    {
                                        DTOProposal.modalidade === 'online' &&
                                        <InputDefault
                                            title="Endereço virtual:"
                                            name="link"
                                            value={DTOProposal.endereco_virtual}
                                            onChangeText={(value) => handleOnChange('endereco_virtual', value)}
                                            className={advancePageError?.email_profissional ? 'big error' : 'big'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                    }
                                </div>                          
                                
                            </div>
                        }

                        {
                            proposalType === 'Diligencia' && formTitle === 'Comparecimento em cartório' &&
                                <div className="bottom">

                                    <div className="subtitle">
                                        Para <span>comparecimento em cartório</span>, informe também:
                                    </div>

                                    <div className="address">
                                        <InputDefault
                                            title="CEP:"
                                            name="Cep"
                                            mask="99999-999"
                                            value={DTOProposal.cep}
                                            onChangeText={(value) => consultCep(value)}
                                            className={advancePageError?.email_profissional ? 'small error' : 'small'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Rua:"
                                            name="rua"
                                            value={cepData.logradouro || DTOProposal.rua}
                                            onChangeText={(value) => handleOnChange('rua', value)}
                                            className={advancePageError?.email_profissional ? 'big error' : 'big'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Bairro:"
                                            name="bairro"
                                            value={cepData.bairro || DTOProposal.bairro}
                                            onChangeText={(value) => handleOnChange('bairro', value)}
                                            className={advancePageError?.email_profissional ? 'mid error' : 'mid'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Número:"
                                            name="numero"
                                            value={DTOProposal.numero}
                                            onChangeText={(value) => handleOnChange('numero', value)}
                                            className={advancePageError?.email_profissional ? 'num error' : 'num'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Complemento:"
                                            name="complemento"
                                            value={DTOProposal.complemento}
                                            onChangeText={(value) => handleOnChange('complemento', value)}
                                            className={advancePageError?.email_profissional ? 'comp error' : 'comp'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <div className="label-state">
                                            <p>Tipo de cartório:</p>
                                            <Select
                                                name="estado_oab"
                                                styles={states}
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 8,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: comum.colors.interfacePure100,
                                                            primary50: comum.colors.interfacePure100,
                                                            primary: comum.colors.interfacePure100,
                                                        },
                                                    })}
                                                placeholder='Selecionar'
                                                defaultValue={DTOProposal.tipo_cartorio !== '' ? { value: DTOProposal.tipo_cartorio, label: DTOProposal.tipo_cartorio } : ''}
                                                onChange={(selected: any) => handleOnChange('tipo_cartorio', selected.value)}
                                                options={NotariesTypes}
                                            />
                                            <span className="error">{advancePageError?.uf ? '*' : ''}</span>
                                        </div>                                        
                                    </div>
                                </div>
                        }

                        {
                            proposalType === 'Diligencia' && formTitle === 'Cópia parcial' &&
                                <div className="bottom">

                                    <div className="subtitle">
                                        Para <span>cópia parcial</span>, informe também:
                                    </div>

                                    <div className="address">
                                        <InputDefault
                                            title="CEP:"
                                            name="Cep"
                                            mask="99999-999"
                                            value={DTOProposal.cep}
                                            onChangeText={(value) => consultCep(value)}
                                            className={advancePageError?.cep ? 'small error' : 'small'}
                                            error={advancePageError?.cep ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Rua:"
                                            name="rua"
                                            placeholder="Nome da rua"
                                            value={cepData.logradouro || DTOProposal.rua}
                                            onChangeText={(value) => handleOnChange('rua', value)}
                                            className={advancePageError?.rua ? 'big error' : 'big'}
                                            error={advancePageError?.rua ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Bairro:"
                                            name="bairro"
                                            value={cepData.bairro || DTOProposal.bairro}
                                            onChangeText={(value) => handleOnChange('bairro', value)}
                                            className={advancePageError?.email_profissional ? 'mid error' : 'mid'}
                                            error={advancePageError?.bairro ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Número:"
                                            name="numero"
                                            value={DTOProposal.numero}
                                            onChangeText={(value) => handleOnChange('numero', value)}
                                            className={advancePageError?.numero ? 'num error' : 'num'}
                                            error={advancePageError?.numero ? '*' : ''}
                                        />

                                        <InputDefault
                                            title="Complemento:"
                                            name="complemento"
                                            value={DTOProposal.complemento}
                                            onChangeText={(value) => handleOnChange('complemento', value)}
                                            className={'comp'}
                                            // error={advancePageError?.email_profissional ? '*' : ''}
                                        />                                                                              

                                    </div>
                                </div>
                        }
                        
                        {
                            proposalType === 'Diligencia' && formTitle === 'Cópia integral' &&
                                <div className="bottom">

                                    <div className="subtitle">
                                        Para <span>cópia integral</span>, informe também:
                                    </div>

                                    <div className="address">
                                        <InputDefault
                                            title="CEP:"
                                            name="Cep"
                                            mask="99999-999"
                                            value={DTOProposal.cep}
                                            onChangeText={(value) => consultCep(value)}
                                            className={advancePageError?.email_profissional ? 'small error' : 'small'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Rua:"
                                            name="rua"
                                            value={cepData.logradouro || DTOProposal.rua}
                                            onChangeText={(value) => handleOnChange('rua', value)}
                                            className={advancePageError?.email_profissional ? 'big error' : 'big'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Bairro:"
                                            name="bairro"
                                            value={cepData.bairro || DTOProposal.bairro}
                                            onChangeText={(value) => handleOnChange('bairro', value)}
                                            className={advancePageError?.email_profissional ? 'mid error' : 'mid'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Número:"
                                            name="numero"
                                            value={DTOProposal.numero}
                                            onChangeText={(value) => handleOnChange('numero', value)}
                                            className={advancePageError?.email_profissional ? 'num error' : 'num'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Complemento:"
                                            name="complemento"
                                            value={DTOProposal.complemento}
                                            onChangeText={(value) => handleOnChange('complemento', value)}
                                            className={advancePageError?.email_profissional ? 'comp error' : 'comp'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />                                                                              
                                    </div>
                                </div>
                        }

                        {
                            proposalType === 'Protocolo' && formTitle === 'Acautelamento' &&
                                <div className="bottom">

                                    <div className="subtitle">
                                        Para <span>acautelamento</span>, informe também:
                                    </div>

                                    <div className="address">
                                        <InputDefault
                                            title="CEP:"
                                            name="Cep"
                                            mask="99999-999"
                                            value={DTOProposal.cep}
                                            onChangeText={(value) => consultCep(value)}
                                            className={advancePageError?.email_profissional ? 'small error' : 'small'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Rua:"
                                            name="rua"
                                            value={cepData.logradouro || DTOProposal.rua}
                                            onChangeText={(value) => handleOnChange('rua', value)}
                                            className={advancePageError?.email_profissional ? 'big error' : 'big'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Bairro:"
                                            name="bairro"
                                            value={cepData.bairro || DTOProposal.bairro}
                                            onChangeText={(value) => handleOnChange('bairro', value)}
                                            className={advancePageError?.email_profissional ? 'mid error' : 'mid'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Número:"
                                            name="numero"
                                            value={DTOProposal.numero}
                                            onChangeText={(value) => handleOnChange('numero', value)}
                                            className={advancePageError?.email_profissional ? 'num error' : 'num'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Complemento:"
                                            name="complemento"
                                            value={DTOProposal.complemento}
                                            onChangeText={(value) => handleOnChange('complemento', value)}
                                            className={advancePageError?.email_profissional ? 'comp error' : 'comp'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />                                                                              
                                    </div>
                                </div>
                        }

                        {
                            proposalType === 'Protocolo' && formTitle === 'Protocolo postal' &&
                                <div className="bottom">

                                    <div className="subtitle">
                                        Para <span>protocolo postal</span>, informe também:
                                    </div>

                                    <div className="address">
                                        <InputDefault
                                            title="CEP:"
                                            name="Cep"
                                            mask="99999-999"
                                            value={DTOProposal.cep}
                                            onChangeText={(value) => consultCep(value)}
                                            className={advancePageError?.email_profissional ? 'small error' : 'small'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Rua:"
                                            name="rua"
                                            value={cepData.logradouro || DTOProposal.rua}
                                            onChangeText={(value) => handleOnChange('rua', value)}
                                            className={advancePageError?.email_profissional ? 'big error' : 'big'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Bairro:"
                                            name="bairro"
                                            value={cepData.bairro || DTOProposal.bairro}
                                            onChangeText={(value) => handleOnChange('bairro', value)}
                                            className={advancePageError?.email_profissional ? 'mid error' : 'mid'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Número:"
                                            name="numero"
                                            value={DTOProposal.numero}
                                            onChangeText={(value) => handleOnChange('numero', value)}
                                            className={advancePageError?.email_profissional ? 'num error' : 'num'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />
                                        <InputDefault
                                            title="Complemento:"
                                            name="complemento"
                                            value={DTOProposal.complemento}
                                            onChangeText={(value) => handleOnChange('complemento', value)}
                                            className={advancePageError?.email_profissional ? 'comp error' : 'comp'}
                                            error={advancePageError?.email_profissional ? '*' : ''}
                                        />                                                                              
                                    </div>
                                </div>
                        }

                    </form>
                }

                {
                    activePage === 2 &&
                    <ServicesTags 
                        tagSelected={tagsSelecteds} 
                        setTagSelected={setTagSelecteds} 
                        reuseTags={DTOProposal.tags}
                    />
                }

                {
                    activePage === 3 &&
                    <SearchProfessionalProposal 
                        uf={countieProps.uf} 
                        cidade={countieProps.cidade}
                        proposalData={DTOProposal}  
                        proposalType={proposalType} 
                        userSelected={handleOnChange}
                        selected={DTOProposal.id_usuario}   
                        nameUser={setNameProfessional}   
                        reuseProfessional={DTOProposal.id_usuario}               
                        reuseProposal={reuseProposal}
                    />
                }

                {
                    activePage === 4 &&
                    <DeadlineProposal 
                        handleOnChange={handleOnChange}
                        deadline={setDeadline}
                        reuseDeadline={location.state.proposal?.prazo_aceite}
                        reuseConclusionDate={location.state.proposal?.prazo_para_conclusao}
                        reuseFiles={location.state.proposal?.arquivos}
                        reuseOrientations={location.state.proposal?.orientacoes[0]}
                        reuseProposal={reuseProposal}
                    />
                }
            </Main>

            <Footer>
                <div className="container">
                    {
                        activePage !== 1 &&
                        <div className="back">
                            <ButtonDefault
                                className="cancel"
                                onClick={() => history.push('/demandas')}
                            >
                                Cancelar
                            </ButtonDefault>
                        </div>
                    }
                    <div className="buttons">
                        {
                            activePage === 1 &&
                            <ButtonDefault
                                className="cancel"
                                onClick={() => history.goBack()}
                            >
                                Cancelar
                            </ButtonDefault>
                        }
                        {
                            activePage > 1 &&
                            <ButtonDefault
                                className="cancel"
                                onClick={() => {
                                    if(activePage === 4 && user.profile === 'Solicitante') {
                                        setActivePage(activePage - 2);
                                    } else {
                                        setActivePage(activePage - 1);
                                    }
                                }}
                            >
                                Voltar
                            </ButtonDefault>
                        }

                        <ButtonDefault
                            className="continue"
                            type="submit"
                            onClick={() => advancePage()}
                            disabled={loading}
                        >
                            Continuar
                        </ButtonDefault>
                    </div>                    
                </div>
            </Footer>

        </Container>
    )
}
